import { z } from "zod";
import { ShortString } from "./primitives";

/*
 * Base struct for Timestamps used in Firestore. Exists to support
 * that both frontend and backend can use the same type since due
 * firebase packaging it's not otherwise possible.
 */
export const FirebaseTimestamp = z.object({
    nanoseconds: z.number().optional(),
    seconds: z.number().optional(),
    _nanoseconds: z.number().optional(),
    _seconds: z.number().optional(),
});

/*
 * Data structure for urls links
 */
export const Link = z.object({
    id: z.string(),
    url: z.union([z.literal(""), z.url()]),
    title: ShortString,
});

/*
 * Represents contributions for philanthropic causes made by a member
 */
export const Contributions = z.object({
    trees: z.int().nonnegative(),
    kilograms: z.int().nonnegative(),
    squareMeters: z.int().nonnegative(),
});

export type FirebaseTimestamp = z.infer<typeof FirebaseTimestamp>;
export type Link = z.infer<typeof Link>;
export type Contributions = z.infer<typeof Contributions>;
